import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/chuku_ic_cangku@2x.png'
import _imports_1 from '@/assets/icon/gongdan_ic_shoudong@2x.png'
import _imports_2 from '@/assets/icon/chuku_ic_delete@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-26eb1638"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = {
  key: 0,
  class: "page_info"
}
const _hoisted_3 = {
  key: 0,
  class: "page_info_title"
}
const _hoisted_4 = {
  key: 1,
  class: "page_info_title"
}
const _hoisted_5 = { class: "page_info_list" }
const _hoisted_6 = { class: "page_info_list_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源类型：", -1))
const _hoisted_8 = {
  key: 0,
  class: "page_info_list_item_nr"
}
const _hoisted_9 = {
  key: 1,
  class: "page_info_list_item_nr"
}
const _hoisted_10 = {
  key: 2,
  class: "page_info_list_item_nr"
}
const _hoisted_11 = {
  key: 3,
  class: "page_info_list_item_nr"
}
const _hoisted_12 = {
  key: 4,
  class: "page_info_list_item_nr"
}
const _hoisted_13 = {
  key: 5,
  class: "page_info_list_item_nr"
}
const _hoisted_14 = { class: "page_info_list_item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请人员：", -1))
const _hoisted_16 = {
  key: 0,
  class: "page_info_list_item_nr"
}
const _hoisted_17 = {
  key: 1,
  class: "page_info_list_item_nr"
}
const _hoisted_18 = { class: "page_info_list_items" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源单号：", -1))
const _hoisted_20 = { class: "page_info_list_item_nr" }
const _hoisted_21 = { class: "page_info_list_items" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请时间：", -1))
const _hoisted_23 = { class: "page_info_list_item_nr" }
const _hoisted_24 = {
  key: 2,
  class: "page_info_bz"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_bz_title" }, "转库备注：", -1))
const _hoisted_26 = { class: "page_info_bz_nr" }
const _hoisted_27 = {
  key: 1,
  class: "page_info"
}
const _hoisted_28 = { class: "page_info_title" }
const _hoisted_29 = { class: "page_info_list" }
const _hoisted_30 = { class: "page_info_list_item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源类型：", -1))
const _hoisted_32 = {
  key: 0,
  class: "page_info_list_item_nr"
}
const _hoisted_33 = {
  key: 1,
  class: "page_info_list_item_nr"
}
const _hoisted_34 = {
  key: 2,
  class: "page_info_list_item_nr"
}
const _hoisted_35 = {
  key: 3,
  class: "page_info_list_item_nr"
}
const _hoisted_36 = {
  key: 4,
  class: "page_info_list_item_nr"
}
const _hoisted_37 = {
  key: 5,
  class: "page_info_list_item_nr"
}
const _hoisted_38 = { class: "page_info_list_items" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "来源单号：", -1))
const _hoisted_40 = { class: "page_info_list_item_nr" }
const _hoisted_41 = { class: "page_info_list_item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请人员：", -1))
const _hoisted_43 = {
  key: 0,
  class: "page_info_list_item_nr"
}
const _hoisted_44 = {
  key: 1,
  class: "page_info_list_item_nr"
}
const _hoisted_45 = { class: "page_info_list_items" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_list_item_label" }, "申请时间：", -1))
const _hoisted_47 = { class: "page_info_list_item_nr" }
const _hoisted_48 = {
  key: 0,
  class: "page_info_bz"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_info_bz_title" }, "转库备注：", -1))
const _hoisted_50 = { class: "page_info_bz_nr" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_52 = { class: "page_sfq" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_dck" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "待入库物料")
  ])
], -1))
const _hoisted_55 = { class: "page_content_title" }
const _hoisted_56 = { class: "page_content_title_top" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "page_content_title_bottom" }
const _hoisted_60 = {
  key: 0,
  class: "green"
}
const _hoisted_61 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_64 = [
  _hoisted_61,
  _hoisted_62,
  _hoisted_63
]
const _hoisted_65 = {
  key: 1,
  class: "warning"
}
const _hoisted_66 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_69 = [
  _hoisted_66,
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = {
  key: 2,
  class: "error"
}
const _hoisted_71 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_74 = [
  _hoisted_71,
  _hoisted_72,
  _hoisted_73
]
const _hoisted_75 = { key: 3 }
const _hoisted_76 = {
  key: 0,
  class: "page_sfq"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_dck" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "page_dck_title_x" }),
    /*#__PURE__*/_createElementVNode("span", null, "待入库物料")
  ])
], -1))
const _hoisted_79 = ["name"]
const _hoisted_80 = { class: "page_content_title" }
const _hoisted_81 = { class: "page_content_title_top" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { class: "page_content_title_bottom" }
const _hoisted_85 = {
  key: 0,
  class: "green"
}
const _hoisted_86 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_89 = [
  _hoisted_86,
  _hoisted_87,
  _hoisted_88
]
const _hoisted_90 = {
  key: 1,
  class: "warning"
}
const _hoisted_91 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_93 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_94 = [
  _hoisted_91,
  _hoisted_92,
  _hoisted_93
]
const _hoisted_95 = {
  key: 2,
  class: "error"
}
const _hoisted_96 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_98 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_99 = [
  _hoisted_96,
  _hoisted_97,
  _hoisted_98
]
const _hoisted_100 = { key: 3 }
const _hoisted_101 = { class: "page_content_list" }
const _hoisted_102 = { class: "page_content_list_item" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "入库货位：", -1))
const _hoisted_104 = { class: "page_content_list_item_nr" }
const _hoisted_105 = { class: "page_content_list_items" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_content_list_item_label" }, "数量：", -1))
const _hoisted_107 = { class: "page_content_list_item_nr" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_109 = { class: "page_yxwl" }
const _hoisted_110 = { class: "page_yxwl_title" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "page_yxwl_title_x" }),
  /*#__PURE__*/_createElementVNode("span", null, "已选择物料")
], -1))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手动入库", -1))
const _hoisted_114 = [
  _hoisted_112,
  _hoisted_113
]
const _hoisted_115 = {
  key: 0,
  class: "page_yxwl_list"
}
const _hoisted_116 = { class: "page_yxwl_list_item_top" }
const _hoisted_117 = { class: "page_yxwl_list_item_top_left" }
const _hoisted_118 = { class: "page_yxwl_list_item_sx" }
const _hoisted_119 = {
  key: 0,
  class: "green"
}
const _hoisted_120 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_122 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_123 = [
  _hoisted_120,
  _hoisted_121,
  _hoisted_122
]
const _hoisted_124 = {
  key: 1,
  class: "warning"
}
const _hoisted_125 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_126 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_127 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_128 = [
  _hoisted_125,
  _hoisted_126,
  _hoisted_127
]
const _hoisted_129 = {
  key: 2,
  class: "red"
}
const _hoisted_130 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_132 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_133 = [
  _hoisted_130,
  _hoisted_131,
  _hoisted_132
]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_135 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_136 = { class: "page_yxwl_list_item_num" }
const _hoisted_137 = { class: "dis" }
const _hoisted_138 = { class: "item" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "入库货位：", -1))
const _hoisted_140 = { class: "nr" }
const _hoisted_141 = { class: "items" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "数量：", -1))
const _hoisted_143 = { class: "nr" }
const _hoisted_144 = ["onUpdate:modelValue"]
const _hoisted_145 = { class: "label" }
const _hoisted_146 = { class: "nr" }
const _hoisted_147 = ["onClick"]
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_149 = [
  _hoisted_148
]
const _hoisted_150 = {
  key: 1,
  class: "page_yxwl_list"
}
const _hoisted_151 = { class: "page_yxwl_list_item_top" }
const _hoisted_152 = { class: "page_yxwl_list_item_top_left" }
const _hoisted_153 = { class: "page_yxwl_list_item_sx" }
const _hoisted_154 = {
  key: 0,
  class: "green"
}
const _hoisted_155 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_157 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_158 = [
  _hoisted_155,
  _hoisted_156,
  _hoisted_157
]
const _hoisted_159 = {
  key: 1,
  class: "yellow"
}
const _hoisted_160 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_162 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_163 = [
  _hoisted_160,
  _hoisted_161,
  _hoisted_162
]
const _hoisted_164 = {
  key: 2,
  class: "red"
}
const _hoisted_165 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_167 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_168 = [
  _hoisted_165,
  _hoisted_166,
  _hoisted_167
]
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_170 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_171 = { class: "page_yxwl_list_item_num" }
const _hoisted_172 = { class: "itemy" }
const _hoisted_173 = { class: "itemy_item" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "入库货位：", -1))
const _hoisted_175 = { class: "nr" }
const _hoisted_176 = { class: "itemy_item" }
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "数量：", -1))
const _hoisted_178 = { class: "nr" }
const _hoisted_179 = ["onUpdate:modelValue"]
const _hoisted_180 = ["onClick"]
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_182 = [
  _hoisted_181
]
const _hoisted_183 = {
  key: 2,
  class: "page_yxwl_kong"
}
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_zw" }, null, -1))
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认入库", -1))
const _hoisted_186 = [
  _hoisted_185
]
const _hoisted_187 = {
  key: 0,
  class: "smrk"
}
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "smrk_header" }, "扫码入库", -1))
const _hoisted_189 = { class: "smrk_content" }
const _hoisted_190 = { class: "smrk_content_name" }
const _hoisted_191 = { key: 0 }
const _hoisted_192 = { key: 1 }
const _hoisted_193 = { class: "smrk_content_sx" }
const _hoisted_194 = {
  key: 0,
  class: "green"
}
const _hoisted_195 = /*#__PURE__*/_createTextVNode("合格 ")
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_197 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_198 = [
  _hoisted_195,
  _hoisted_196,
  _hoisted_197
]
const _hoisted_199 = {
  key: 1,
  class: "yellow"
}
const _hoisted_200 = /*#__PURE__*/_createTextVNode("不良 ")
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_202 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_203 = [
  _hoisted_200,
  _hoisted_201,
  _hoisted_202
]
const _hoisted_204 = {
  key: 2,
  class: "error"
}
const _hoisted_205 = /*#__PURE__*/_createTextVNode("报废 ")
const _hoisted_206 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "black" }, "/", -1))
const _hoisted_207 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_208 = [
  _hoisted_205,
  _hoisted_206,
  _hoisted_207
]
const _hoisted_209 = { key: 3 }
const _hoisted_210 = {
  key: 0,
  class: "smrk_content_gz"
}
const _hoisted_211 = {
  key: 1,
  class: "smrk_content_gz"
}

import { ref, reactive, onMounted, nextTick, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'
    import { useStore } from "vuex"
    import { Toast } from 'vant'
    import { QRCodeType } from '@/enum'
    import {
        getList,
        outScanAppliances,
        getLocationInfo,
        saveIn,
        getInByWTransferId,
        wTransferForInOut,
        wOutBoundForInOut,
        wOutBoundForUpload,
        transferToInNew
    } from '@/apis/ExWarehouse'
    import { wTransferForInOutUpload } from '@/apis/ExWarehouse'
    import { getBarcodeContent, getListByCondition, getListByWarehouseId } from '@/apis/WorkOrderAPI'
    import { getDB } from '@/apis/agencyAPI'
    // import vScanCode from '@/components/common/ScanCode.vue'
    import Allocation from '@/components/common/allocation.vue'
    import MaterialIn from '@/components/common/materialIn.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()
    const store = useStore()
    const router = useRouter()

    let hwCode = ref<string>('')
    let info: any = ref({})
    let openCode1 = ref<boolean>(false)
    let show = ref<boolean>(false)  // 控制弹框打开
    let show1 = ref<boolean>(false)  // 控制弹框打开

    let show2 = ref<boolean>(false)  // 控制弹框打开
    let MateriaList = ref<object[]>([])    // 物料
    let seleMateriaList = ref<object[]>([])    // 已选物料
    let location = ref<string | number>('')     // 货位id
    let locationName = ref<string | number>('')     // 货位名称

    let ids = ref<string>('')
    let itemData: any = ref({}) // 已扫描数据
    let warehouseId = ref<string>('')   // 仓库编码

    const activeNames = ref([0])   // 控制手风琴打开

    let data: any = ref([])   // 详情数据

    let selected: any = ref([])   // 已选数据

    const whouseArray: any = ref([])     // 转库列表数据

    let smData: any = reactive({     // 扫码记录后续操作数据
        wz: [],
        item: [],
        info: []
    })

    const status = ref() // 0 待入库 1 已入库

    const type: string = route.query.type as string  // 7 转库单  9 入库单

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 修改入库数量
    const inputNum = (item: any) => {
        let totalNum = 0
        seleMateriaList.value.forEach((element: any) => {
            if (element.id === item.id) {
                totalNum += Number(element.outActnum)
            }
        })
        info.value.wtransferWarehouseList[0].wtransferDetailList.forEach((element: any) => {
            if (element.materialId === item.materialId) {
                if (element.outActnum < totalNum) {
                    item.outActnum = ''
                    Toast.fail({ message: '待入库数量不能小于已选择物料数量', duration: 2000 })
                }
            }
        })
        console.log(totalNum)
    }

    // 选择物料
    const getValue1 = async (obj: any) => {
        let val: any = JSON.parse(JSON.stringify(obj))
        // 判断相同货位相同物料只能有一个
        for (let i = 0; i < seleMateriaList.value.length; i++) {
            if (seleMateriaList.value[i].locationId === location.value) {
                if (seleMateriaList.value[i].qualityType == obj.qualityType &&
                seleMateriaList.value[i].procedureId == obj.procedureId &&
                seleMateriaList.value[i].batch == obj.batch &&
                seleMateriaList.value[i].materialId == obj.materialId) {
                    Toast.fail({ message: '相同货位，同一个物料只能有一个', duration: 2000 })
                    show2.value = false
                    return
                }
                // if (val.materialId === seleMateriaList.value[i].materialId) {
                //     Toast.fail({ message: '相同货位，同一个物料只能有一个', duration: 2000 })
                //     show2.value = false
                //     return
                // }
            }
        }
        // 判断物料数量不能超出待入库数量
        let materialNum = 0
        let num = 0
        seleMateriaList.value.forEach((item: any) => {
            if (item.id === val.id) {
                materialNum += Number(item.outActnum)
            }
        })
        info.value.wtransferWarehouseList[0].wtransferDetailList.forEach((item: any) => {
            if (item.id === val.id) {
                num = item.outActnum - materialNum
            }
        })
        val['outActnum'] = num

        seleMateriaList.value.push({ ...val, locationId: location.value, locationName: locationName.value })
        show2.value = false
    }

    // 提交工装
    const getValue = async (val: any, i: number) => {
        // for(let i = 0; i < seleMateriaList.value.length; i++) {
        //     if (seleMateriaList.value[i].locationId === val.id) {
        //         Toast.fail({ message: '不能重复选择货位', duration: 2000 })
        //         return
        //     }
        // }
        // 如果没有工装了，就收起弹框
        // if (i === 0) {
            show1.value = false
        // }
        location.value = val.id
        locationName.value = val.unionName
        show2.value = true
        // let sweepHw = await getBarcodeContent({
        //     barcode: hwCode.value
        // })
        // if (sweepHw.code === 200) {
        //     if (sweepHw.data.barcodeType === QRCodeType.HW) {
        //         // show1.value = true
        //         let hw = await getLocationInfo(sweepHw.data.id)
        //         if (hw.code === 200) {
        //             let judge: string = ''
        //             info.value.wtransferWarehouseList.forEach((item: any) => {
        //                 if (hw.data.warehouseId === item.warehouseId) {
        //                     judge = ''
        //                     outScanAppliances({
        //                         barCode: val.prefix + val.code,
        //                         pId: info.value.wtransfer.id,
        //                         type: 1,
        //                         warehouseId: hw.data.warehouseId,
        //                         locationId: hw.data.id
        //                     }).then(sweepGz => {
        //                         if (sweepGz.code === 200) {
        //                             item.wtransferDetailList.forEach(async (item1: any) => {
        //                                 if (sweepGz.data.materialId === item1.materialId && sweepGz.data.qualityType === item1.qualityType && sweepGz.data.procedureId === item1.procedureId && sweepGz.data.batch === item1.batch) {
        //                                     judge = ''
        //                                     let jsonBean = sweepGz.data
        //                                     jsonBean.wtransferDetailId = item1.id
        //                                     jsonBean.wtransferId = item1.transferId
        //                                     jsonBean.appliancesId = sweepGz.data.id
        //                                     jsonBean.warehouseId = item.warehouseId
        //                                     jsonBean.warehouseName = item.warehouseName
        //                                     jsonBean.locationId = hw.data.id
        //                                     jsonBean.locationName = hw.data.unionName
        //                                     let res = await wTransferForInOut({
        //                                         id: Number(route.query.id),
        //                                         wTransferType: 1,
        //                                         jsonBean: jsonBean,
        //                                         optType: 1
        //                                     })
        //                                     if (res.code === 200) {
        //                                         let open = await getInfo()
        //                                         Toast.success({ message: '操作成功' })
        //                                         return
        //                                     } else {
        //                                         return
        //                                     }
        //                                     // })
        //                                 } else {
        //                                     judge = 'wu'
        //                                 }
        //                             })
        //                         } else {
        //                             return
        //                         }
        //                     })
        //                 } else {
        //                     judge = 'ck'
        //                 }
        //             })
        //             if (judge === 'ck') {
        //                 Toast.fail({ message: '仓库不一致' })
        //             } else if (judge === 'wu') {
        //                 Toast.fail({ message: '未匹配到一致的数据' })
        //             }
        //         }
        //     } else {
        //         Toast({ message: '请扫描正确的货位码' })
        //         return
        //     }
        // }
        // show.value = false
    }

    const onDecode1 = async (datas: string[]) => {
        let arr: any = []
        if (info.value.wtransferRedisCodeBeanList.length !== 0) {
            info.value.wtransferRedisCodeBeanList.forEach((element: any) => {
                arr.push(element.appliancesId)
            })
            ids.value = arr.join(',')
        } else {
            ids.value = ''
        }
        hwCode.value = datas[0]
        show1.value = true
        openCode1.value = false
    }

    // 打开手动选择工装弹框
    const openxz = () => {
        // openCode1.value = true
        getListByWarehouseId({ wareHouseId: warehouseId.value })
            .then(res => {
                if (res.code === 200) {
                    if (res.data.length === 1) {
                        location.value = res.data[0].id
                        locationName.value = res.data[0].unionName
                        show2.value = true
                    } else {
                        show1.value = true
                    }
                }
            })
        
    }

    const closeBox = () => {
        show1.value = false
    }
    const closeBox1 = () => {
        show2.value = false
    }

    // 获取详情
    const getInfo = async (): Promise<boolean> => {
        if (type === QRCodeType.ZKD.toString()) {
            console.log('转库单')
            let res = await wTransferForInOut({
                id: Number(route.query.id),
                wTransferType: 1
            })
            if (res.code === 200) {
                info.value = res.data
                warehouseId.value = res.data.wtransfer.inWarehouseId.toString()
                MateriaList.value = res.data.wtransferWarehouseList[0].wtransferDetailList
                return true
            } else {
                Toast.fail({ message: res.message, forbidClick: false, duration: 2000 })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        } else if (type === QRCodeType.RKD.toString()) {
            console.log('入库单')
            let res = await wOutBoundForInOut({
                id: Number(route.query.id),
                wOutboundType: 1
            })
            if (res.code === 200) {
                info.value = res.data
                return true
            } else {
                Toast.fail({ message: res.message, forbidClick: false, duration: 2000 })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        }
        return false
    }


    // 打开扫码
    const scanCode = (): void => {
        if (type === QRCodeType.RKD.toString()){
            if (info.value.warehouse && info.value.warehouse.useLocation === 1) {
                smData.info = ['请扫描货位码', '请扫描工装码']
            } else if (info.value.warehouse && info.value.warehouse.useLocation === 0) {
                smData.info = ['请扫描工装码']
            }
        } else {
            smData.info = ['请扫描货位码', '请扫描工装码']
        }
        openCode.value = true
    }

    // 弹框打开扫码
    const JXSM = (): void => {
        smData.info = ['请扫描工装码']
        openCode.value = true
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 关闭扫码组件
    const closePopup1 = (): void => {
        openCode1.value = false
    }

    // 提交入库
    const submit = () => {
        if (type === QRCodeType.ZKD.toString()) {
            if (seleMateriaList.value.length > 0) {
                let result = seleMateriaList.value.reduce((a: any, b: any) => {
                    if (a[b.id]) {
                        a[b.id].push(b);
                    } else {
                        a[b.id] = [b];
                    }
                        return a;
                }, {});
                for (let i = 0; i < info.value.wtransferWarehouseList[0].wtransferDetailList.length; i++) {
                    for (let a in result) {
                        if (info.value.wtransferWarehouseList[0].wtransferDetailList[i].id == a) {
                            let total = 0
                            for (let b = 0; b < result[a].length; b++) {
                                total = Number(total) + Number(result[a][b].outActnum)
                            }
                            if (!total || total <= 0) {
                                return Toast.fail({ message: '入库数量不能小于0', forbidClick: true, duration: 2000 })
                            }
                            if (total > info.value.wtransferWarehouseList[0].wtransferDetailList[i].outActnum) {
                                return Toast.fail({ message: '入库数量不能大于待入库数量', forbidClick: true, duration: 2000 })
                            }
                        }
                    }
                }
                let submitTransferInDetailDTOList: any = []
                seleMateriaList.value.forEach((item: any) => {
                    submitTransferInDetailDTOList.push({
                        inNum: item.outActnum,
                        locationId: item.locationId,
                        wtransferDetailId: item.id
                    })
                })
                transferToInNew({
                    submitTransferInDetailDTOList,
                    wtransferId: route.query.id
                }).then(res => {
                    if (res.code === 200) {
                        store.dispatch('getUpcomingNum')
                        Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
                        setTimeout(() => {
                            if (route.query.Type == '4') {  // 跳转完工入库详情
                                router.push({ name: 'completionDetails', query: { id: route.query.id, dbid: route.query.dbid, type: 7, isShow: 2 } })
                                return
                            }
                            router.replace({ name: 'wTransferDetail', query: { id: route.query.id } })
                        }, 2000)
                    }
                })
            } else {
                Toast.fail({ message: '转入物料不能为空', forbidClick: true, duration: 2000 })
            }
            // wTransferForInOutUpload({
            //     id: info.value.wtransfer.id,
            //     wTransferType: 1
            // }).then(res => {
            //     if (res.code === 200) {
            //         store.dispatch('getUpcomingNum')
            //         Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
            //         setTimeout(() => {
            //             // router.go(-1)
            //             if (route.query.Type == '4') {  // 跳转完工入库详情
            //                 router.push({ name: 'completionDetails', query: { id: route.query.id, dbid: route.query.dbid, type: 7, isShow: 2 } })
            //                 return
            //             }
            //             router.replace({ name: 'wTransferDetail', query: { id: route.query.id } })
            //         }, 2000)
            //     }
            // })
        } else if (type === QRCodeType.RKD.toString()) {
            wOutBoundForUpload({
                id: info.value.woutbound.id,
                wOutboundType: 1
            }).then(res => {
                if (res.code === 200) {
                    store.dispatch('getUpcomingNum')
                    Toast.success({ message: '操作成功', forbidClick: true, duration: 2000 })
                    setTimeout(() => {
                        // router.go(-1)
                        router.replace({ name: 'wInboundDetail', query: { id: route.query.id } })
                    }, 2000)
                }
            })
        }
    }

    // 删除操作
    const dele = (i: number) => {
        if (type === QRCodeType.ZKD.toString()) {
            seleMateriaList.value.forEach((item: any, index: number) => {
                if (i == index) {
                    seleMateriaList.value.splice(index, 1)
                }
            })
            // wTransferForInOut({
            //     id: Number(route.query.id),
            //     wTransferType: 1,
            //     optType: 2,
            //     jsonBean: item
            // }).then(res => {
            //     if (res.code === 200) {
            //         getInfo()
            //     }
            // })
        } else if (type === QRCodeType.RKD.toString()) {
            wOutBoundForInOut({
                id: Number(route.query.id),
                wOutboundType: 1,
                optType: 2,
                jsonBean: item
            }).then(res => {
                if (res.code === 200) {
                    getInfo()
                }
            })
        }
    }

    // 点击弹框保存
    const submitTK = () => {
        itemData.value = {}
        show.value = false
    }

    // 获取扫码值
    const onDecode = async (datas: string[]): Promise<void> => {
        await nextTick(() => {
            openCode.value = false
        })
        if (type == QRCodeType.RKD.toString()) {   // 入库单
            if (info.value.warehouse.useLocation === 0) {   // 禁用货位
                let type = await getBarcodeContent({
                    barcode: datas[0]
                })
                if (type.code === 200) {
                    if (type.data.barcodeType === QRCodeType.GZ) {
                        let gz = await getListByCondition({ id: type.data.id })
                        if (gz.code === 200) {
                            let open: boolean = false
                            let jsonBean: any = {}
                            jsonBean.woutboundId = Number(route.query.id)
                            jsonBean.appliancesId = gz.data[0].id
                            jsonBean.scanCode = datas[0]
                            jsonBean.warehouseId = info.value.warehouse.id
                            jsonBean.warehouseName = info.value.warehouse.name
                            jsonBean.materialId = gz.data[0].materialId
                            jsonBean.materialCode = gz.data[0].mmodelCode
                            jsonBean.materialName = gz.data[0].mmodelName
                            for(let i = 0; i < info.value.woutboundDetailsWait.length; i++) {
                                // 判断批次号和物料id工序是否一致
                                if (info.value.woutboundDetailsWait[i].batch === gz.data[0].batch && info.value.woutboundDetailsWait[i].materialId === gz.data[0].materialId && info.value.woutboundDetailsWait[i].procedureId === gz.data[0].procedureId) {
                                    open = true
                                    jsonBean.woutboundDetailId = info.value.woutboundDetailsWait[i].id
                                    jsonBean.unitid = info.value.woutboundDetailsWait[i].unitId
                                    jsonBean.unitName = info.value.woutboundDetailsWait[i].unitName
                                    jsonBean.batch = info.value.woutboundDetailsWait[i].batch
                                    jsonBean.num = info.value.woutboundDetailsWait[i].num
                                    jsonBean.procedureId = info.value.woutboundDetailsWait[i].procedureId
                                    jsonBean.procedureName = info.value.woutboundDetailsWait[i].pmodelName
                                    jsonBean.qualityType = info.value.woutboundDetailsWait[i].qualityType
                                    let submit = await wOutBoundForInOut({
                                        id: Number(route.query.id),
                                        wOutboundType: 1,
                                        jsonBean: jsonBean,
                                        optType: 1
                                    })
                                    if (submit.code === 200) {
                                        console.log(submit)
                                        getInfo()
                                    }
                                }
                            }
                            if (!open) {
                                Toast.fail({ message: '数据不一致' })
                            }
                        }
                    } else {
                        Toast.fail({ message: '请扫描正确的工装码' })
                    }
                }
                return
            }
            if (smData.info.length === 1) {     // 弹框里的继续扫码
                let res = await outScanAppliances({
                    barCode: datas.join(' '),
                    pId: info.value.woutbound.id,
                    type: 3,
                    warehouseId: itemData.value.ckid,
                    locationId: itemData.value.locationId
                })
                if (res.code === 200) {
                    let judge: string = ''
                    if (itemData.value.materialId === res.data.materialId) {
                        judge = ''
                        info.value.woutboundDetailsWait.forEach((item: any) => {
                            if (itemData.value.materialId === item.materialId && res.data.qualityType == item.qualityType && res.data.procedureId == item.procedureId && res.data.batch == item.batch) {
                                judge = ''
                                let jsonBean = res.data
                                jsonBean.woutboundDetailId = item.id
                                jsonBean.woutboundId = item.outboundId
                                jsonBean.wtransferDetailId = item.id
                                jsonBean.wtransferId = item.transferId
                                jsonBean.appliancesId = res.data.id
                                jsonBean.warehouseId = info.value.woutbound.warehouseId
                                jsonBean.warehouseName = info.value.woutbound.warehouseName
                                jsonBean.locationId = itemData.value.locationId
                                jsonBean.locationName = itemData.value.locationName
                                wOutBoundForInOut({
                                    id: Number(route.query.id),
                                    wOutboundType: 1,
                                    jsonBean: jsonBean,
                                    optType: 1
                                }).then(async (resa) => {
                                    if (resa.code === 200) {
                                        let open = await getInfo()
                                        if (open) {
                                            info.value.woScanMaterialBeanList.forEach((yitem: any) => {
                                                if (yitem.locationId === itemData.value.locationId) {
                                                    itemData.value = yitem
                                                    itemData.value.ckmc = info.value.woutbound.warehouseName
                                                    itemData.value.ckid = info.value.woutbound.warehouseId
                                                    itemData.value.wtransferDetailId = item.id
                                                    itemData.value.wtransferId = item.id
                                                    itemData.value.wtransferId = item.transferId
                                                    itemData.value.appliancesId = res.data.id
                                                    itemData.value.total = item.num
                                                    console.log('itemData', itemData.value)
                                                }
                                            })
                                        }
                                    } else {
                                        return
                                    }
                                })
                            } else {
                                judge = 'wu'
                            }
                        })
                    } else {
                        judge = 'ck'
                    }
                    if (judge === 'ck') {
                        Toast.fail({ message: '仓库不一致' })
                    } else if (judge === 'wu') {
                        Toast.fail({ message: '未匹配到一致的数据' })
                    }
                }
            } else if (smData.info.length === 2) {     // 页面上的继续扫码
                // 货位操作
                let sweepHw = await getBarcodeContent({
                    barcode: datas[0]
                })
                if (sweepHw.code === 200) {
                    if (sweepHw.data.barcodeType === QRCodeType.HW) {
                        let hw = await getLocationInfo(sweepHw.data.id)
                        if (hw.code === 200) {
                            let judge: string = ''
                            if (info.value.woutbound.warehouseId === hw.data.warehouseId) {
                                judge = ''
                                for (let i = 0; i < info.value.woutboundDetailsWait.length; i++) {
                                    if (info.value.woutboundDetailsWait[i].locationId ? info.value.woutboundDetailsWait[i].locationId === hw.data.id : true) {
                                        judge = ''
                                        let sweepGz = await outScanAppliances({
                                            barCode: datas[1],
                                            pId: info.value.woutbound.id,
                                            type: 3,
                                            warehouseId: hw.data.warehouseId,
                                            locationId: hw.data.id
                                        })
                                        if (sweepGz.code === 200) {
                                            for (let i = 0; i < info.value.woutboundDetailsWait.length; i++) {
                                                // sweepGz.data.procedureId == info.value.woutboundDetailsWait[i].procedureId &&
                                                if (info.value.woutboundDetailsWait[i].materialId === sweepGz.data.materialId && sweepGz.data.qualityType == info.value.woutboundDetailsWait[i].qualityType && sweepGz.data.batch == info.value.woutboundDetailsWait[i].batch) {
                                                    judge = ''
                                                    let jsonBean = sweepGz.data
                                                    jsonBean.woutboundDetailId = info.value.woutboundDetailsWait[i].id
                                                    jsonBean.woutboundId = info.value.woutboundDetailsWait[i].outboundId
                                                    jsonBean.appliancesId = sweepGz.data.id
                                                    jsonBean.locationId = hw.data.id
                                                    jsonBean.warehouseId = info.value.woutbound.warehouseId
                                                    jsonBean.warehouseName = info.value.woutbound.warehouseName
                                                    jsonBean.locationName = hw.data.unionName
                                                    console.log(jsonBean)
                                                    let tj = await wOutBoundForInOut({
                                                        id: Number(route.query.id),
                                                        wOutboundType: 1,
                                                        jsonBean: jsonBean,
                                                        optType: 1
                                                    })
                                                    if (tj.code === 200) {
                                                        let open = await getInfo()
                                                        if (open) {
                                                            info.value.woScanMaterialBeanList.forEach((yitem1: any) => {
                                                                if (yitem1.locationId === hw.data.id) {
                                                                    itemData.value = yitem1
                                                                    itemData.value.ckmc = info.value.woutbound.warehouseName
                                                                    itemData.value.ckid = info.value.woutbound.warehouseId
                                                                    itemData.value.wtransferDetailId = info.value.woutboundDetailsWait[i].id
                                                                    itemData.value.wtransferId = info.value.woutboundDetailsWait[i].id
                                                                    itemData.value.wtransferId = info.value.woutboundDetailsWait[i].transferId
                                                                    itemData.value.appliancesId = sweepGz.data.id
                                                                    itemData.value.total = info.value.woutboundDetailsWait[i].num
                                                                    console.log('itemData', itemData.value)
                                                                    nextTick(() => {
                                                                        show.value = true
                                                                    })
                                                                }
                                                            })
                                                            await nextTick(() => {
                                                                show.value = true
                                                            })
                                                            return
                                                        }
                                                    } else {
                                                        Toast({ message: tj.message })
                                                        return
                                                    }
                                                } else {
                                                    judge = 'wu'
                                                }
                                            }
                                        } else {
                                            Toast({ message: sweepGz.message })
                                            return
                                        }
                                    } else {
                                        judge = 'wu'
                                    }
                                }
                            } else {
                                judge = 'ck'
                            }
                            if (judge === 'ck') {
                                Toast.fail({ message: '仓库不一致' })
                            } else if (judge === 'wu') {
                                Toast.fail({ message: '未匹配到一致的数据' })
                            }
                        }
                    } else {
                        Toast({ message: '请扫描正确的货位码' })
                        return
                    }
                } else {
                    Toast({ message: sweepHw.message })
                    return
                }
            }
        } else if (type == QRCodeType.ZKD.toString()) {   // 转库单
            if (smData.info.length === 1) {     // 弹框里的继续扫码
                let res = await outScanAppliances({
                    barCode: datas.join(' '),
                    pId: info.value.wtransfer.id,
                    type: 1,
                    warehouseId: itemData.value.ckid,
                    locationId: itemData.value.locationId
                })
                if (res.code === 200) {
                    if (itemData.value.materialId === res.data.materialId) {
                        let judge: string = ''
                        info.value.wtransferWarehouseList.forEach((item: any) => {
                            if (itemData.value.ckid === item.warehouseId) {  // 判断仓库是否一致
                                judge = ''
                                item.wtransferDetailList.forEach((item1: any) => {
                                    if (itemData.value.materialId === item1.materialId && res.data.qualityType == item1.qualityType && res.data.procedureId == item1.procedureId && res.data.batch === item1.batch) {     // 物料一致
                                        judge = ''
                                        let jsonBean = res.data
                                        jsonBean.wtransferDetailId = item1.id
                                        jsonBean.wtransferId = item1.transferId
                                        jsonBean.appliancesId = res.data.id
                                        jsonBean.warehouseId = item.warehouseId
                                        jsonBean.warehouseName = item.warehouseName
                                        jsonBean.locationId = itemData.value.locationId
                                        jsonBean.locationName = itemData.value.locationName
                                        wTransferForInOut({
                                            id: Number(route.query.id),
                                            wTransferType: 1,
                                            jsonBean: jsonBean,
                                            optType: 1
                                        }).then(async (resa) => {
                                            if (resa.code === 200) {
                                                let open = await getInfo()
                                                if (open) {
                                                    info.value.wtransferWarehouseList.forEach((yitem: any) => {
                                                        if (yitem.warehouseId === item.warehouseId) {
                                                            yitem.wtScanMaterialBeanList.forEach((yitem1: any) => {
                                                                if (yitem1.locationId === itemData.value.locationId) {
                                                                    itemData.value = yitem1
                                                                    itemData.value.ckmc = item.warehouseName
                                                                    itemData.value.ckid = item.warehouseId
                                                                    itemData.value.wtransferDetailId = item1.id
                                                                    itemData.value.wtransferId = item1.id
                                                                    itemData.value.wtransferId = item1.transferId
                                                                    itemData.value.appliancesId = res.data.id
                                                                    itemData.value.total = item1.outPlannum
                                                                }
                                                            })
                                                        }
                                                    })
                                                    return
                                                }
                                            } else {
                                                return
                                            }
                                        })
                                    } else {
                                        judge = 'wu'
                                    }
                                })
                            } else {
                                judge = 'ck'
                            }
                        })
                        if (judge === 'ck') {
                            Toast.fail({ message: '仓库不一致' })
                        } else if (judge === 'wu') {
                            Toast.fail({ message: '未匹配到一致的数据' })
                        }
                    } else {
                        Toast.fail({ message: '物料不一致' })
                    }
                }
            } else if (smData.info.length === 2) {     // 页面上的继续扫码
                // 货位操作
                let sweepHw = await getBarcodeContent({
                    barcode: datas[0]
                })
                if (sweepHw.code === 200) {
                    if (sweepHw.data.barcodeType === QRCodeType.HW) {
                        let hw = await getLocationInfo(sweepHw.data.id)
                        if (hw.code === 200) {
                            let judge: string = ''
                            info.value.wtransferWarehouseList.forEach((item: any) => {
                                console.log(hw.data.warehouseId, item.warehouseId)
                                if (hw.data.warehouseId === item.warehouseId) {
                                    judge = ''
                                    outScanAppliances({
                                        barCode: datas[1],
                                        pId: info.value.wtransfer.id,
                                        type: 1,
                                        warehouseId: hw.data.warehouseId,
                                        locationId: hw.data.id
                                    }).then(sweepGz => {
                                        if (sweepGz.code === 200) {
                                            item.wtransferDetailList.forEach(async (item1: any) => {
                                                if (sweepGz.data.materialId === item1.materialId && sweepGz.data.qualityType === item1.qualityType && sweepGz.data.procedureId === item1.procedureId && sweepGz.data.batch === item1.batch) {
                                                    judge = ''
                                                    let jsonBean = sweepGz.data
                                                    jsonBean.wtransferDetailId = item1.id
                                                    jsonBean.wtransferId = item1.transferId
                                                    jsonBean.appliancesId = sweepGz.data.id
                                                    jsonBean.warehouseId = item.warehouseId
                                                    jsonBean.warehouseName = item.warehouseName
                                                    jsonBean.locationId = hw.data.id
                                                    jsonBean.locationName = hw.data.unionName
                                                    let res = await wTransferForInOut({
                                                        id: Number(route.query.id),
                                                        wTransferType: 1,
                                                        jsonBean: jsonBean,
                                                        optType: 1
                                                    })
                                                    if (res.code === 200) {
                                                        let open = await getInfo()
                                                        if (open) {
                                                            info.value.wtransferWarehouseList.forEach((yitem: any) => {
                                                                if (yitem.warehouseId === item.warehouseId) {
                                                                    yitem.wtScanMaterialBeanList.forEach((yitem1: any) => {
                                                                        if (yitem1.locationId === hw.data.id) {
                                                                            itemData.value = yitem1
                                                                            itemData.value.ckmc = item.warehouseName
                                                                            itemData.value.ckid = item.warehouseId
                                                                            itemData.value.wtransferDetailId = item1.id
                                                                            itemData.value.wtransferId = item1.id
                                                                            itemData.value.wtransferId = item1.transferId
                                                                            itemData.value.appliancesId = sweepGz.data.id
                                                                            itemData.value.total = item1.outPlannum
                                                                            console.log('itemData', itemData.value)
                                                                            nextTick(() => {
                                                                                show.value = true
                                                                            })
                                                                        }
                                                                    })
                                                                }
                                                            })
                                                            return
                                                        }
                                                    } else {
                                                        return
                                                    }
                                                    // })
                                                } else {
                                                    judge = 'wu'
                                                }
                                            })
                                        } else {
                                            return
                                        }
                                    })
                                } else {
                                    judge = 'ck'
                                }
                            })
                            if (judge === 'ck') {
                                Toast.fail({ message: '仓库不一致' })
                            } else if (judge === 'wu') {
                                Toast.fail({ message: '未匹配到一致的数据' })
                            }
                        }
                    } else {
                        Toast({ message: '请扫描正确的货位码' })
                        return
                    }
                }
            }
        }
    }

    // 获取待办详情(判断当前待办是否已处理)
    const getDBs = async (id: string): Promise<any> => {
        let res = await getDB(id)
        if (res.code === 200) {
            if (res.data.status === 1) {
                if (type === '7') {
                    await router.replace({ name: 'wTransferDetail', query: { id: route.query.id } })
                } else if (type === '9') {
                    await router.replace({ name: 'wInboundDetail', query: { id: route.query.id } })
                }
            } else {
                await getInfo()
            }
        }
    }

    // 监听弹框
    watch(() => show.value, (news) => {
        if (!news) {
            smData.wz = []
            smData.item = []
        }
    }, { immediate: true })

    onMounted(() => {
        if (route.query.dbid) {
            getDBs(route.query.dbid as string)
        } else {
            getInfo()
        }
    })

return (_ctx: any,_cache: any) => {
  const _component_van_collapse_item = _resolveComponent("van-collapse-item")!
  const _component_van_collapse = _resolveComponent("van-collapse")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(info).wtransfer && _unref(type) === _unref(QRCodeType).ZKD.toString())
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(info).wtransfer.inPlandate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString('计划入库日期：' + _unref(info).wtransfer.inPlandate), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString('计划入库日期：' + _unref(info).wtransfer.planDate), 1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_unref(info).wtransfer.originType === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "采购订单"))
                : (_unref(info).wtransfer.originType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, "生产工单"))
                  : (_unref(info).wtransfer.originType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, "销售订单"))
                    : (_unref(info).wtransfer.originType === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, "转库单"))
                      : (_unref(info).wtransfer.originType === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "盘点单"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_13, "-"))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              (_unref(info).wtransfer.userName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_unref(info).wtransfer.userName + '/' + _unref(info).wtransfer.userDepartName), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_unref(info).wtransfer.inUserName + '/' + _unref(info).wtransfer.inDepartName), 1))
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(info).wtransfer.originCode ? _unref(info).wtransfer.originCode : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(info).wtransfer.createTime ? _unref(info).wtransfer.createTime : '-'), 1)
            ])
          ]),
          (_unref(info).wtransfer.abstracts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(info).wtransfer.abstracts), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(info).woutbound && _unref(type) === _unref(QRCodeType).RKD.toString())
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, _toDisplayString('计划入库日期：' + _unref(info).woutbound.planDate), 1),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              (_unref(info).woutbound.originType === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, "采购订单"))
                : (_unref(info).woutbound.originType === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, "生产工单"))
                  : (_unref(info).woutbound.originType === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, "销售订单"))
                    : (_unref(info).woutbound.originType === 3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, "转库单"))
                      : (_unref(info).woutbound.originType === 4)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, "盘点单"))
                        : (_openBlock(), _createElementBlock("div", _hoisted_37, "-"))
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(info).woutbound.originCode ? _unref(info).woutbound.originCode : '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              (_unref(info).woutbound.userName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(_unref(info).woutbound.userName + '/' + _unref(info).woutbound.userDepartName), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(info).woutbound.inUserName + '/' + _unref(info).woutbound.inDepartName), 1))
            ]),
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(info).woutbound.createTime ? _unref(info).woutbound.createTime : '-'), 1)
            ])
          ]),
          (_unref(info).woutbound.abstracts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _hoisted_49,
                _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(info).woutbound.abstracts), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_51,
    _createVNode(_component_van_collapse, {
      modelValue: activeNames.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeNames).value = $event))
    }, {
      default: _withCtx(() => [
        (_unref(route).query.type == 7)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(info).wtransferWarehouseList, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_collapse_item, {
                key: index,
                name: index
              }, {
                title: _withCtx(() => [
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createTextVNode(" " + _toDisplayString(item.warehouseName), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _hoisted_54,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.wtransferDetailList, (item1, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "page_content",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          (item1.batch)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(item1.materialName + ' | ' + item1.materialCode), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(item1.materialName + ' | ' + item1.materialCode), 1)),
                          _createElementVNode("span", null, _toDisplayString(item1.outActnum) + _toDisplayString(item1.unitName), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          (item1.qualityType === 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_60, _hoisted_64))
                            : (item1.qualityType === 1)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_65, _hoisted_69))
                              : (item1.qualityType === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_70, _hoisted_74))
                                : (_openBlock(), _createElementBlock("span", _hoisted_75, "- / ")),
                          _createElementVNode("span", null, _toDisplayString(item1.procedureName ? item1.procedureName : '-') + " / ", 1),
                          _createElementVNode("span", null, _toDisplayString(item1.batch ? item1.batch : '-'), 1)
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          : _createCommentVNode("", true),
        (_unref(route).query.type == 9)
          ? (_openBlock(), _createBlock(_component_van_collapse_item, { key: 1 }, {
              title: _withCtx(() => [
                (_unref(info).woutbound)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                      _hoisted_77,
                      _createTextVNode(" " + _toDisplayString(_unref(info).woutbound.warehouseName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _hoisted_78,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).woutboundDetailsWait, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "page_content",
                    key: index,
                    name: index
                  }, [
                    _createElementVNode("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        (item.batch)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(item.materialName + ' | ' + item.materialCode), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(item.materialName + ' | ' + item.materialCode), 1))
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        (item.qualityType === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_85, _hoisted_89))
                          : (item.qualityType === 1)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_90, _hoisted_94))
                            : (item.qualityType === 2)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_95, _hoisted_99))
                              : (_openBlock(), _createElementBlock("span", _hoisted_100, "- / ")),
                        _createElementVNode("span", null, _toDisplayString(item.procedureName ? item.procedureName : '-') + " / ", 1),
                        _createElementVNode("span", null, _toDisplayString(item.batch ? item.batch : '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("div", _hoisted_102, [
                        _hoisted_103,
                        _createElementVNode("div", _hoisted_104, _toDisplayString(item.locationName ? item.locationName : '-'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_105, [
                        _hoisted_106,
                        _createElementVNode("div", _hoisted_107, _toDisplayString(item.num ? item.num : '-') + _toDisplayString(item.unitName), 1)
                      ])
                    ])
                  ], 8, _hoisted_79))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _hoisted_108,
    _createElementVNode("div", _hoisted_109, [
      _createElementVNode("div", _hoisted_110, [
        _hoisted_111,
        (_unref(type) === _unref(QRCodeType).ZKD.toString())
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "right",
              onClick: openxz
            }, _hoisted_114))
          : _createCommentVNode("", true)
      ]),
      (_unref(route).query.type == 9 && _unref(info).woScanMaterialBeanList && _unref(info).woScanMaterialBeanList.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).woScanMaterialBeanList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "page_yxwl_list_item",
                key: index
              }, [
                _createElementVNode("div", _hoisted_116, [
                  _createElementVNode("div", _hoisted_117, _toDisplayString(item.materialName) + " | " + _toDisplayString(item.materialCode), 1)
                ]),
                _createElementVNode("div", _hoisted_118, [
                  (item.qualityType === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_119, _hoisted_123))
                    : (item.qualityType === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_124, _hoisted_128))
                      : (item.qualityType === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_129, _hoisted_133))
                        : _createCommentVNode("", true),
                  _createElementVNode("span", null, [
                    _createTextVNode(_toDisplayString(item.procedureName ? item.procedureName : '-') + " ", 1),
                    _hoisted_134,
                    _hoisted_135
                  ]),
                  _createElementVNode("span", null, _toDisplayString(item.batch ? item.batch : '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_136, [
                  _createElementVNode("div", _hoisted_137, [
                    _createElementVNode("div", _hoisted_138, [
                      _hoisted_139,
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("span", null, _toDisplayString(item.locationName ? item.locationName : '-'), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_141, [
                      _hoisted_142,
                      _createElementVNode("div", _hoisted_143, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": ($event: any) => ((item.scanNum) = $event),
                          placeholder: "请输入"
                        }, null, 8, _hoisted_144), [
                          [_vModelText, item.scanNum]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(item.unitName), 1)
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.woutboundRedisCodeBeanList, (item1, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "itemy",
                      key: idx
                    }, [
                      _createElementVNode("div", _hoisted_145, "工装" + _toDisplayString(item1.scanCode) + "：", 1),
                      _createElementVNode("div", _hoisted_146, _toDisplayString(item1.num) + _toDisplayString(item1.unitName), 1),
                      _createElementVNode("div", {
                        class: "dele",
                        onClick: ($event: any) => (dele(item1))
                      }, _hoisted_149, 8, _hoisted_147)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ]))
        : (_unref(route).query.type == 7 && _unref(seleMateriaList).length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_150, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(seleMateriaList), (item1, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "page_yxwl_list_item",
                  key: idx
                }, [
                  _createElementVNode("div", _hoisted_151, [
                    _createElementVNode("div", _hoisted_152, _toDisplayString(item1.materialName) + " | " + _toDisplayString(item1.materialCode), 1)
                  ]),
                  _createElementVNode("div", _hoisted_153, [
                    (item1.qualityType === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_154, _hoisted_158))
                      : (item1.qualityType === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_159, _hoisted_163))
                        : (item1.qualityType === 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_164, _hoisted_168))
                          : _createCommentVNode("", true),
                    _createElementVNode("span", null, [
                      _createTextVNode(_toDisplayString(item1.procedureName ? item1.procedureName : '-') + " ", 1),
                      _hoisted_169,
                      _hoisted_170
                    ]),
                    _createElementVNode("span", null, _toDisplayString(item1.batch ? item1.batch : '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_171, [
                    _createElementVNode("div", _hoisted_172, [
                      _createElementVNode("div", _hoisted_173, [
                        _hoisted_174,
                        _createElementVNode("div", _hoisted_175, [
                          _createElementVNode("span", null, _toDisplayString(item1.locationName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_176, [
                        _hoisted_177,
                        _createElementVNode("div", _hoisted_178, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": ($event: any) => ((item1.outActnum) = $event),
                            placeholder: "请输入"
                          }, null, 8, _hoisted_179), [
                            [_vModelText, item1.outActnum]
                          ]),
                          _createElementVNode("span", null, _toDisplayString(item1.unitName), 1)
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "dele",
                        onClick: ($event: any) => (dele(idx))
                      }, _hoisted_182, 8, _hoisted_180)
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_183, "暂无数据"))
    ]),
    _hoisted_184,
    _createElementVNode("div", { class: "page_footer" }, [
      _createElementVNode("div", {
        class: "page_footer_ck",
        onClick: submit
      }, _hoisted_186)
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      position: "bottom",
      closeable: true,
      style: { height: '60%' },
      round: ""
    }, {
      default: _withCtx(() => [
        (_unref(itemData))
          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
              _hoisted_188,
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("div", _hoisted_190, [
                  (_unref(itemData).batch)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_191, _toDisplayString(_unref(itemData).materialName) + " | " + _toDisplayString(_unref(itemData).materialCode) + " | " + _toDisplayString(_unref(itemData).batch), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_192, _toDisplayString(_unref(itemData).materialName) + " | " + _toDisplayString(_unref(itemData).materialCode), 1)),
                  _createElementVNode("span", null, _toDisplayString(_unref(itemData).scanNum) + "/" + _toDisplayString(_unref(itemData).total) + _toDisplayString(_unref(itemData).unitName), 1)
                ]),
                _createElementVNode("div", _hoisted_193, [
                  (_unref(itemData).qualityType === 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_194, _hoisted_198))
                    : (_unref(itemData).qualityType === 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_199, _hoisted_203))
                      : (_unref(itemData).qualityType === 2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_204, _hoisted_208))
                        : (_openBlock(), _createElementBlock("span", _hoisted_209, "- / ")),
                  _createElementVNode("span", null, _toDisplayString(_unref(itemData).procedureName ? _unref(itemData).procedureName : '-') + " / ", 1),
                  _createElementVNode("span", null, _toDisplayString(_unref(itemData).batch ? _unref(itemData).batch : '-'), 1)
                ]),
                (_unref(itemData).wtransferRedisCodeBeanList)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_210, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemData).wtransferRedisCodeBeanList, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "smrk_content_gz_item",
                          key: index
                        }, [
                          _createElementVNode("span", null, _toDisplayString(item.scanCode) + "：", 1),
                          _createElementVNode("span", null, _toDisplayString(item.num) + _toDisplayString(item.unitName), 1)
                        ]))
                      }), 128))
                    ]))
                  : (_unref(itemData).woutboundRedisCodeBeanList)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(itemData).woutboundRedisCodeBeanList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "smrk_content_gz_item",
                            key: index
                          }, [
                            _createElementVNode("span", null, _toDisplayString(item.scanCode) + "：", 1),
                            _createElementVNode("span", null, _toDisplayString(item.num) + _toDisplayString(item.unitName), 1)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", { class: "smrk_footer" }, [
                _createElementVNode("div", {
                  class: "smrk_footer_jx",
                  onClick: JXSM
                }, "继续扫码"),
                _createElementVNode("div", {
                  class: "smrk_footer_bc",
                  onClick: submitTK
                }, "保存")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Allocation, {
      show: _unref(show1),
      warehouseId: _unref(warehouseId),
      onClose: closeBox,
      onValue: getValue
    }, null, 8, ["show", "warehouseId"]),
    _createVNode(MaterialIn, {
      show: _unref(show2),
      list: _unref(MateriaList),
      onClose: closeBox1,
      onValue: getValue1
    }, null, 8, ["show", "list"])
  ]))
}
}

})